module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "book"
  }, [_c('div', {
    staticClass: "coverInfo"
  }, [_c('img', {
    staticClass: "coverImage",
    attrs: {
      "src": "//textcafe.co/books/1BF6If3/tc-custom/9781427866516.jpg?1709205915386",
      "alt": "This image is the cover for the book Van Von Hunter, Volume 2, Van Von Hunter"
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "bookInfo"
  }, [_c('h1', {
    staticClass: "bookTitle heading font1"
  }, [_vm._v("Van Von Hunter, Volume 2, Van Von Hunter\n    ")]), _vm._v(" "), _c('p', {
    staticClass: "bookDescription body article font2"
  }), _c('p', [_c('b', [_vm._v("The adventures of a dim-witted hero and his sidekick continue as they encounter the undead, cookie-baking elves, and more in this funny, fantasy manga.")])]), _c('p', [_vm._v(" Continuing their journey through the lands of Dikay, fighting the most horrid, totally wicked stuff ever imagined, Van Von Hunter and Sidekick encounter lots and lots of evil! Not only does everyone’s favorite decaying jester Laspo return to wreak havoc, but we also meet the lovely, scantily armored Adonette, the famous necromancer, who treats her rotting zombie hordes as family. ")]), _c('p', [_vm._v(" Throw in something scary lurking in a secret labyrinth and a surprise that will put lumps in your cookie dough, and you can bet your sweet tooth that Van Von Hunter and his sidekick are in more trouble than you can swing a sword at—or a giant crossbow! ")]), _c('p', [_c('b', [_vm._v("Based on the much beloved online comic.")])]), _c('p', [_c('b', [_vm._v("Praise for "), _c('i', [_vm._v("Van Von Hunter, Volume 1")])])]), _c('b', [_vm._v("“[A] humorous adventure. . . . The figures are well-designed and likable. . . . An amusing quick read.” —"), _c('i', [_vm._v("Publishers Weekly")])]), _vm._v(" "), _c('p')]), _vm._v(" "), _c('div', {
    staticClass: "authorInfo"
  }, [_c('h2', {
    staticClass: "authorName heading font1"
  }, [_vm._v("\n      Mike Schwark, Ron Kaulfersch.\n    ")])]), _vm._v(" "), _c('div', {
    staticClass: "publisherInfo"
  }, [_c('h2', {
    staticClass: "publisherName heading font1"
  }, [_vm._v("\n    Tokyopop Verlag\n   ")])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-638a3f51","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/home.vue
// module id = 71
// module chunks = 0